module.exports = __webpack_public_path__ + "img/02.8c8d6f21.jpg";